import { I18nComponente } from "@/types/gerais"

export const UsarLeitorDeDadosi18n: I18nComponente = {
  "pt-BR": {
    parametroNaoEncontrado: "Parâmetro 'por-pagina' não encontrado."
  },
  "es-CO": {
    parametroNaoEncontrado: "Parámetro 'por-pagina' no encontrado."
  },
}
